import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star-half",
  "use": "star-half-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"star-half\"><path d=\"m22 9.2-7.2-.6L12 2 9.2 8.6 2 9.2 7.5 14l-1.6 7 6.2-3.7 6.2 3.7-1.6-7zm-10 6.2V6.1l1.7 4 4.4.4-3.3 2.9 1 4.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol